import { Box } from '@mantine/core';
import { DateValue } from '@mantine/dates';
import { useState } from 'react';

import { TriggersAnalyticsData } from '../components/Triggers/AnalyticsData';
import { TriggersControlsPanel } from '../components/Triggers/ControlsPanel';

import { Platforms } from '@/types';
import { endOfDay, startOfDay } from '@/utils/dates';

export type FiltersState = {
  dates: [DateValue, DateValue];
  expertIds: string[];
  platform: Platforms | 'all';
};

const getDefaultFilters = (): FiltersState => {
  const today = new Date();
  return {
    dates: [startOfDay(today), endOfDay(today)],
    expertIds: [],
    platform: Platforms.telegram,
  };
};

export const Triggers = () => {
  const [filters, setFilters] = useState<FiltersState>(getDefaultFilters);

  return (
    <Box>
      <TriggersControlsPanel
        setFilters={(updatedState) => setFilters((previous) => ({ ...previous, ...updatedState }))}
        filters={filters}
      />
      <TriggersAnalyticsData {...filters} />
    </Box>
  );
};
